import React from "react";
import { Megaphone } from "lucide-react";
import { TC_RADIUS } from "../../constants/templateCreatorConstants";

const STEPS = [
  { num: 1, label: "Set up template" },
  { num: 2, label: "Edit template" },
  { num: 3, label: "Submit for Review" },
];

export default function TemplateCreatorStepBar({ current }) {
  const activeStep = STEPS.find((s) => s.num === current) || STEPS[0];

  return (
    <nav
      aria-label="Template creation progress"
      className="flex flex-wrap items-center gap-x-2.5 gap-y-1 text-[13px] leading-normal text-[#65676b]"
    >
      <span className="font-medium text-[#8a8d91]">
        {current}/{STEPS.length}
      </span>

      <span className="text-[#ccd0d5]" aria-hidden>
        ·
      </span>

      <ol className="flex flex-wrap items-center gap-x-2 list-none m-0 p-0">
        {STEPS.map((step, index) => {
          const done = current > step.num;
          const active = current === step.num;

          return (
            <li key={step.num} className="flex items-center gap-x-2">
              {index > 0 && (
                <span className="text-[#ccd0d5] select-none" aria-hidden>
                  /
                </span>
              )}
              <span
                aria-current={active ? "step" : undefined}
                className={
                  active
                    ? "font-semibold text-[#1877f2]"
                    : done
                      ? "font-medium text-[#050505]"
                      : "font-normal text-[#8a8d91]"
                }
              >
                {step.label}
              </span>
            </li>
          );
        })}
      </ol>

      <span className="sr-only">
        Current step: {activeStep.label}
      </span>
    </nav>
  );
}

export function TemplateSummaryBanner({ name, languageLabel, category, subtypeLabel }) {
  return (
    <div className={`mt-4 border border-[#dddfe2] bg-white px-4 py-3 flex items-center gap-3 ${TC_RADIUS}`}>
      <div className={`w-10 h-10 bg-[#31a24c] flex items-center justify-center shrink-0 ${TC_RADIUS}`}>
        <Megaphone size={20} className="text-white" strokeWidth={2.5} />
      </div>
      <div className="min-w-0">
        <p className="text-[15px] font-semibold text-[#050505] truncate">
          {name || "your_template_name"}
          <span className="text-[#65676b] font-semibold"> · </span>
          {languageLabel}
        </p>
        <p className="text-[13px] text-[#65676b] capitalize">
          {category?.toLowerCase()} · {subtypeLabel}
        </p>
      </div>
    </div>
  );
}
